export default "__VITE_ASSET__ab384c86__"